module.exports = __webpack_public_path__ + "img/coating-antistatic-cover.c2cdac8e.png";